import { IntlMessageFormat } from "intl-messageformat";
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type ApiErrorBody, type Locale } from "@agentsaas/protocol";
import en from "../catalogs/en.json" with { type: "json" };
import zhCN from "../catalogs/zh-CN.json" with { type: "json" };

export type Catalog = Record<string, string>;
export type MessageKey = keyof typeof en;

/** en 是 key 的基准目录；其他语言必须有完全相同的 key 集（scripts/check.ts 校验）。 */
export const catalogs: Record<Locale, Catalog> = { en, "zh-CN": zhCN };

/** 按 Accept-Language / 用户设置挑一个支持的 locale。 */
export function negotiateLocale(wanted: string | null | undefined): Locale {
  if (!wanted) return DEFAULT_LOCALE;
  for (const part of wanted.split(",")) {
    const tag = part.split(";")[0]?.trim().toLowerCase();
    if (!tag) continue;
    const exact = SUPPORTED_LOCALES.find((l) => l.toLowerCase() === tag);
    if (exact) return exact;
    const lang = SUPPORTED_LOCALES.find((l) => l.toLowerCase().split("-")[0] === tag.split("-")[0]);
    if (lang) return lang;
  }
  return DEFAULT_LOCALE;
}

const cache = new Map<string, IntlMessageFormat>();

/** 渲染一条消息；缺 key 时回退到 en，再缺则返回 key 本身（便于发现遗漏）。 */
export function t(locale: Locale, key: string, params?: Record<string, unknown>): string {
  const src = catalogs[locale][key] ?? catalogs[DEFAULT_LOCALE][key];
  if (src === undefined) return key;
  const ck = `${locale}\u0000${key}`;
  let fmt = cache.get(ck);
  if (!fmt) {
    fmt = new IntlMessageFormat(src, locale);
    cache.set(ck, fmt);
  }
  return String(fmt.format(params as Record<string, string | number>));
}

export function errorMessage(locale: Locale, err: Pick<ApiErrorBody, "code" | "params">): string {
  return t(locale, `error.${err.code}`, err.params);
}
